import { USA_STATES } from "@src/appV2/lib/utils";
import { Button } from "@src/appV2/redesign/components/Button";

import { ShiftBottomSheetBookabilityCriteriaCard } from "../BookabilityCriteriaCard";

interface NoLicenseCardProps {
  href: string;
  workplaceState?: string;
}

export function NoLicenseCard(props: NoLicenseCardProps) {
  const { href, workplaceState } = props;

  const stateAbbreviation = workplaceState
    ? USA_STATES.find((state) => state.name === workplaceState)?.key
    : undefined;

  return (
    <ShiftBottomSheetBookabilityCriteriaCard
      title={stateAbbreviation ? `Upload ${stateAbbreviation} License` : "Upload License"}
      description="You need to have a valid license added to your account to book this shift."
      illustrationType="document-upload"
      footer={
        <Button fullWidth href={href} variant="contained" size="medium">
          Upload
        </Button>
      }
    />
  );
}
